import { render } from "./ManualIssue.vue?vue&type=template&id=16cc0f64&scoped=true"
import script from "./ManualIssue.vue?vue&type=script&lang=js"
export * from "./ManualIssue.vue?vue&type=script&lang=js"

import "./ManualIssue.vue?vue&type=style&index=0&id=16cc0f64&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2135/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16cc0f64"]])

export default __exports__